import React, { useState } from 'react';
import { adminServices } from '../services/adminServices';
import { useUser } from '../UserContext';
import { useManagedLanguages } from '../hooks/useManagedLanguages';

const CommsLab = () => {
  const { user, permissions } = useUser();
  const { languageManifest } = useManagedLanguages();
  const [template, setTemplate] = useState('email_activation_pending'); // Updated default
  const [lang, setLang] = useState('en');
  const [targetEmail, setTargetEmail] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [status, setStatus] = useState(null); 

  if (!permissions?.canManageStaff) return null;

  const templates = [
    { key: 'email_activation_pending', label: '1. School: Fresh Signup' },
    { key: 'email_new_registration', label: '2. School: Magic Link' },
    { key: 'email_resume_registration', label: '3. School: Resumption' },
    { key: 'email_factcheck', label: '4. School: Fact-Check' },
    { key: 'email_final', label: '5. School: Final Publication' }
  ];

  const handleTest = async (e) => {
    e.preventDefault();
    if (!targetEmail) {
      setStatus({ type: 'error', msg: 'Please enter a recipient email.' });
      return;
    }

    setIsSending(true);
    setStatus(null);

    try {
      await adminServices.triggerDiagnosticEmail(template, lang, targetEmail, user.displayName, user.uid);
      setStatus({ 
        type: 'success', 
        msg: `Test triggered! Check ${targetEmail} in a few moments. (Backend logs will show the result)` 
      });
    } catch (err) {
      setStatus({ type: 'error', msg: `Failed to trigger: ${err.message}` });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div style={{ 
      background: 'rgba(15, 23, 42, 0.9)', 
      border: '1px solid #138a8a', 
      borderRadius: '12px', 
      padding: '25px', 
      marginBottom: '30px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
      color: 'white'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
        <span style={{ fontSize: '1.2rem' }}>📧</span>
        <h3 style={{ margin: 0, fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '1px', color: '#138a8a' }}>
          Email Checker (Diagnostic Tool)
        </h3>
      </div>

      <form onSubmit={handleTest} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', alignItems: 'flex-end' }}>
        
        <div>
          <label style={{ display: 'block', fontSize: '0.7rem', opacity: 0.6, marginBottom: '8px' }}>SELECT TEMPLATE</label>
          <select 
            value={template} 
            onChange={(e) => setTemplate(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '6px', background: '#0f172a', border: '1px solid #334155', color: 'white' }}
          >
            {templates.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', fontSize: '0.7rem', opacity: 0.6, marginBottom: '8px' }}>LANGUAGE</label>
          <select 
            value={lang} 
            onChange={(e) => setLang(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '6px', background: '#0f172a', border: '1px solid #334155', color: 'white' }}
          >
            {Object.entries(languageManifest).map(([key, info]) => (
              <option key={key} value={key}>{info.nativeName} ({key.toUpperCase()})</option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', fontSize: '0.7rem', opacity: 0.6, marginBottom: '8px' }}>TEST RECIPIENT EMAIL</label>
          <input 
            type="email" 
            placeholder="your-email@example.com"
            value={targetEmail}
            onChange={(e) => setTargetEmail(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '6px', background: '#0f172a', border: '1px solid #334155', color: 'white', boxSizing: 'border-box' }}
          />
        </div>

        <button 
          type="submit" 
          disabled={isSending}
          style={{ 
            padding: '10px 20px', 
            borderRadius: '6px', 
            background: isSending ? '#444' : '#138a8a', 
            color: 'white', 
            border: 'none', 
            fontWeight: 'bold', 
            cursor: isSending ? 'not-allowed' : 'pointer',
            transition: '0.3s'
          }}
        >
          {isSending ? 'SENDING...' : 'SEND TEST'}
        </button>
      </form>

      {status && (
        <div style={{ 
          marginTop: '20px', 
          padding: '12px', 
          borderRadius: '6px', 
          fontSize: '0.85rem',
          background: status.type === 'success' ? 'rgba(74, 222, 128, 0.1)' : 'rgba(248, 113, 113, 0.1)',
          border: `1px solid ${status.type === 'success' ? '#4ade80' : '#f87171'}`,
          color: status.type === 'success' ? '#4ade80' : '#f87171'
        }}>
          {status.msg}
        </div>
      )}

      <p style={{ marginTop: '15px', fontSize: '0.7rem', opacity: 0.4, fontStyle: 'italic', margin: '15px 0 0 0' }}>
        Note: This tool uses the real production Cloud Functions. It will create a temporary record "IFIP Diagnostic Lab" in the registry during the test.
      </p>
    </div>
  );
};

export default CommsLab;